import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { SharedService } from '../../../services/shared.service';
import { Order } from '../../../models/order.model';

@Component({
  standalone: false,
  selector: 'app-production-order-autocomplete',
  templateUrl: './production-order-autocomplete.component.html',
  styleUrls: ['./../autocomplete.component.scss']
})
export class ProductionOrderAutocompleteComponent {
  @Input() items: Array<Order> = [];
  @Input() placeholder?: string;
  input: string = '';
  isListVisible: boolean = false;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  constructor(private sharedService: SharedService,
              private message: MessageService) {}

  getAllItems(): any {
    this.getProductionOrders();
  }

  getProductionOrders(): any {
    this.sharedService.getProductionOrders(this.input).subscribe(
      res => {
        this.items = res.results;
        this.isListVisible = this.items.length > 0 && this.input.length > 0;
      },
      err => {
        this.message.error(err);
      }
    )
  }

  onSelect(item: any): any {
    const order = new Order(item);
    this.selected.emit(order.id);
    this.isListVisible = false;
    this.input =`${item.client} - ${item.name} - ${item.upisId}`;
  }

  trackByFn(index: number): number {
    return index;
  }
}
